import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Skeleton } from 'gatorcomponents';
import * as Styles from './GreetingBanner.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import { useHistory } from 'react-router';

const GreetingBanner = ({
  loading, displayCreateSiteBanner, bannerLocale, event,
}) => {
  const firstName = useSelector(state => state.summary.firstname);
  const { list: userPlans } = useSelector(state => state.sites);
  const history = useHistory();

  const handleClick = () => {
    event && event();
    history.push(bannerLocale.cta.link);
  };

  if (loading) {
    return (
      <Styles.SkeletonWrapper data-testid="greeting-banner">
        <Skeleton height="150px" width="450px" variant="paragraph" />
        <Skeleton height="32px" width="164px" variant="button" />
      </Styles.SkeletonWrapper>
    );
  }

  const activeStatus = ['active', 'to_due', 'overdue'];
  const userHasActivePlans = userPlans.some(plan => activeStatus.includes(plan.status.toLowerCase()));

  return (
    <Styles.GreetingBanner data-testid="greeting-banner">
      <Styles.Row>
        <Styles.Column>
          <Styles.GreetingBannerTitle>{bannerLocale.title(firstName)}</Styles.GreetingBannerTitle>
          <Styles.GreetingBannerSubtitle>{bannerLocale.subtitle}</Styles.GreetingBannerSubtitle>
        </Styles.Column>

        {displayCreateSiteBanner && (
          <Styles.Column>
            <Styles.WrapperButton>
              {userHasActivePlans && (
                <Button
                  label={bannerLocale.cta.label}
                  onClick={() => handleClick()}
                  size="large"
                  testId="button"
                  type="button"
                  variant="tertiary"
                  version="v2"
                  width="fit-content"
                />
              )}
            </Styles.WrapperButton>
          </Styles.Column>
        )}
      </Styles.Row>
    </Styles.GreetingBanner>
  );
};
export default withErrorBoundary(GreetingBanner, 'GreetingBanner');
